import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconSimularModule } from 'pipes/icon-simular/icon-simular.module';

import { IconProviderComponent } from './icon-provider.component';

import { SvgIconModule } from '../svg-icon-module/svg-icon.module';
import { TrustPipeModule } from '../trust/trust.module';

/**
 * Module for define svg icons and use it
 */
@NgModule({
  imports: [CommonModule, SvgIconModule, IconSimularModule, TrustPipeModule],
  declarations: [IconProviderComponent],
  exports: [IconProviderComponent],
})
export class IconProviderModule {}
